export default __webpack_public_path__ + "media/images/favicon-9433e734eea5a60a8b25a53636508020.svg";